import {Flex} from "@adobe/react-spectrum";

export interface ContentMainProps {
    children: JSX.Element | Array<JSX.Element> | any
}

function ContentHeader({children}: ContentMainProps) {
    return (
        <Flex
            alignItems="center"
            height="size-800"
            width="100%"
        >
            {children}
        </Flex>
    )
}

export default ContentHeader;
